/* eslint-disable prefer-const */

import utilService from '../../services/UtilService';
import { t } from '../../services/i18nService';

const timeUtils = {
    /**
     *
     * @param milliseconds
     * @param tr
     * @param forceShowSeconds - used to force showing the 'seconds' part
     * Usually this param is used when ENABLE_CANDIDATE_LEVEL_DURATION MPProp is true
     * then server sends duration in seconds and they need to show.
     * Another case could be when there is audio attached the the test
     * for the candidate that makes the duration be on the "second" level.
     * @returns {string}
     */
    formatDuration(milliseconds, tr, forceShowSeconds) {
        try {
            let ms = milliseconds;
            if (ms < 1000) {
                ms += 1000;
            }
            let { days, hours, minutes, seconds } = this.getTimeUnitsFromDuration(ms);
            const msThreshold = 5 * 60 * 1000; // 5 minutes
            const showSeconds = (forceShowSeconds || ms < msThreshold) && seconds > 0;

            if (!showSeconds) {
                minutes = seconds === 0 ? minutes : minutes + 1;
                if (minutes === 60) {
                    hours++;
                    minutes = 0;
                }
                if (hours === 24) {
                    days++;
                    hours = 0;
                }
            }

            const showDays = days > 0;
            const showHours = (showDays && !isNaN(hours)) || hours > 0;
            const showMinutes = minutes > 0;
            const strArray = [];

            if (showDays) {
                strArray.push(`${days} ${tr('generic.timeUnit.day', { count: days })}`);
            }
            if (showHours) {
                strArray.push(`${hours} ${tr('generic.timeUnit.hour', { count: hours })}`);
            }
            if (showMinutes) {
                strArray.push(`${minutes} ${tr('generic.timeUnit.minute', { count: minutes })}`);
            }
            if (showSeconds) {
                strArray.push(`${seconds} ${tr('generic.timeUnit.second', { count: seconds })}`);
            }

            return strArray.join(', ');
        } catch (error) {
            window.console.error(error);
            return '-';
        }
    },

    /**
     * Creates an object like this {days, hours, minutes, seconds}
     *
     * @param {int} ms
     * @returns {{days, hours, minutes, seconds}}
     */
    getTimeUnitsFromDuration(ms) {
        let days;
        let hours;
        let minutes;
        let seconds;

        seconds = Math.floor(ms / 1000);
        minutes = Math.floor(seconds / 60);
        seconds %= 60;
        hours = Math.floor(minutes / 60);
        minutes %= 60;
        days = Math.floor(hours / 24);
        hours %= 24;

        return { days, hours, minutes, seconds };
    },

    /**
     * @param {int} timeRemaining in milliseconds
     * @param {boolean} showSeconds
     * @param {boolean} isInfinityCausedByLiveSession whether or not infinity should be treated as caused by liveSession.
     * @returns {string}
     */
    getTimeRemainingStrings(timeRemaining, showSeconds, isInfinityCausedByLiveSession = false) {
        let retValue;

        if (timeRemaining === -1) {
            if (isInfinityCausedByLiveSession) {
                retValue = t('timeRemaining.liveSessionInfiniteTime');
            } else {
                retValue = t('timeRemaining.openForReSubmission');
            }
        } else if (timeRemaining === 0) {
            retValue = t('timeRemaining.timedOut');
        } else if (timeRemaining) {
            retValue = t('timeRemaining.timeRemainingStringAndValue', {
                formattedTime: utilService.getReadableDuration(timeRemaining, showSeconds),
            });
        } else {
            retValue = t('timeRemaining.timeRemainingStringAndValue', {
                formattedTime: t('timeRemaining.unknown'),
            });
        }

        return retValue;
    },
};

export default timeUtils;
